export const getAdditionalFeesOrderItems = (fees, fixAdditionalFeeWithoutCode) => fees?.map((fee, index) => ({
  id: fixAdditionalFeeWithoutCode ? fee.code ?? `additional-fee-${index}` : fee.code,
  name: fee.name ?? '',
  price: fee.price?.amount ?? '0',
  quantity: 1
})) || [];
//# sourceMappingURL=getAdditionalFeesOrderItems.js.map